<template>
  <app-chip
    class="bg-primary-100"
    icon="ph:globe-hemisphere-west"
    :size="size"
    tag="dl"
  >
    <template #prepend>
      <app-icon
        v-if="flagIcon"
        class="block overflow-hidden rounded-sm"
        :icon="flagIcon"
        :size="size === 'small' ? 14 : 20"
      />
    </template>
    <dt class="sr-only">
      {{ $t("course.language.chip_label") }}
    </dt>
    <dd class="flex items-center gap-1">
      {{ list }}
    </dd>
  </app-chip>
</template>

<script lang="ts" setup>
const properties = withDefaults(
  defineProps<{
    languages: string[];
    size?: "small";
  }>(),
  {
    size: undefined,
  },
);

const { t } = useI18n();

const list = useI18nList(
  computed(() =>
    properties.languages.map((code) =>
      t(`course.language.locale_label.${code}`),
    ),
  ),
);

const flagIcon = computed(() => {
  if (properties.languages.length > 1) return;

  const locale = properties.languages[0];

  if (locale === "fr") return "flag:fr-4x3";
  if (locale === "en") return "flag:gb-4x3";
});
</script>
